import React from 'react';

/* Live scorecard (#ScorecardCollapse) — the sc_cw-* markup is verbatim from the
   reference (its CSS was inline there; we scoped it into reddy-supplement.css).
   3 columns: teamA (left) · match_status (centre) · teamB (right). Collapsible
   via the `open` prop (React-driven; the `.reddy-home .collapse` Tailwind fix keeps
   the shown state visible). The decorative batsman/bowler SVGs (desktop-only, live
   server) are omitted. Stadium bg → dark-green gradient placeholder in the CSS. */
export default function ScoreCard({ scorecard, open = true }) {
  if (!scorecard) return null;
  const { teamA, teamB, status } = scorecard;

  const Team = ({ team, side }) => (
    <div
      className="sc_cw-team"
      style={side === 'left'
        ? { textAlign: 'right', marginRight: '10px', lineHeight: 2 }
        : { textAlign: 'left', marginLeft: '10px', lineHeight: 2 }}
    >
      <div className="sc_cw-curr_inn">
        <div style={{ lineHeight: 1.2, fontWeight: 600 }}>{team.name}</div>
        <span className="run" style={{ fontWeight: 600 }}>{team.score}&nbsp;</span>
        <span className="over" style={{ fontWeight: 600 }}>{team.overs}</span>
        <br />
        <span className="over" style={{ fontWeight: 600 }}>CRR :</span>{team.crr}
      </div>
    </div>
  );

  return (
    <div id="ScorecardCollapse" className={`collapse${open ? ' show' : ''}`}>
      <div style={{ marginBottom: '3px' }}>
        <div className="sc_cw-container-main">
          <div className="sc_cw-row-ctm">
            <Team team={teamA} side="left" />

            <div className="sc_cw-match_status" style={{ border: '1px solid #fff', borderRadius: '7px', padding: '5px' }}>
              <span className="sc_cw-commantry2">{status.event}</span>
              <p className="sc_cw-target" style={{ fontStyle: 'italic' }}>Target {status.target}</p>
              <span className="sc_cw-day">
                <div className="sc_cw-score-over">
                  <ul>
                    {/* the reference separates the balls with source whitespace (inline-block
                        word-spacing); JSX strips it, so re-add an explicit space after each */}
                    {status.balls.map((b, i) => (
                      <React.Fragment key={i}>
                        <li className="sc_cw-six-balls">{b}</li>{' '}
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </span>
              <div className="sc_cw-requiredRunRate" style={{ fontWeight: 600 }}>
                <span style={{ fontWeight: 600 }}>{status.text}
                  <span style={{ fontWeight: 600 }}> | RRR: {status.rrr}</span>
                </span>
              </div>
              <div className="sc_cw-batsman-container">
                {status.batsmen.map((bm, i) => (
                  <div key={i}>
                    {/* reference has whitespace between the name and figures spans */}
                    <span>{bm.striker ? '*' : ''}{bm.name}</span>{' '}
                    <span>{bm.figures}</span>
                  </div>
                ))}
              </div>
            </div>

            <Team team={teamB} side="right" />
          </div>
        </div>
      </div>
    </div>
  );
}
